export default "__VITE_ASSET__CaFLy72t__"